import React from 'react';
import { Typography, Row, Col, Card, Button, Divider, Space, Tag, List, theme } from 'antd';
import {
  ApiOutlined,
  ToolOutlined,
  SafetyCertificateOutlined,
  TeamOutlined,
  GlobalOutlined,
  RocketOutlined,
} from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;

const GetHelp = () => {
  const { token } = theme.useToken();

  const sectionStyle = {
    padding: 20,
    backgroundColor: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    border: `1px solid ${token.colorBorderSecondary}`,
    marginTop: 16,
  };

  const services = [
    {
      icon: <ApiOutlined style={{ fontSize: 24, color: '#4573D2' }} />,
      title: 'Integration & Custom App Development',
      description:
        'Connect Asana to Slack, Salesforce, Jira, Google Workspace, Microsoft 365 and more. We build custom apps like this Attachment Manager to extend Asana for your specific needs.',
    },
    {
      icon: <ToolOutlined style={{ fontSize: 24, color: '#4573D2' }} />,
      title: 'Ongoing Support & Optimisation',
      description:
        'Dedicated support to keep your Asana environment running smoothly. We refine workflows, implement new features, and help you get the most out of your investment.',
    },
    {
      icon: <TeamOutlined style={{ fontSize: 24, color: '#4573D2' }} />,
      title: 'Licensing & Consultancy',
      description:
        'Expert guidance on Asana licensing, workspace architecture, rollout planning, training, and change management.',
    },
  ];

  return (
    <Row justify="center">
      <Col span={18}>
        <Title level={3}>Get Help with Asana</Title>

        <Paragraph style={sectionStyle}>
          <Space direction="vertical" size="small">
            <Text>
              <strong>BDQ</strong> is a trusted{' '}
              <Text strong>Asana Solutions Partner</Text>, helping organisations
              in the UK, US and worldwide get the most from Asana.
            </Text>
            <Text>
              Remote-first and flexible, BDQ provides consultancy, integration,
              custom app development and ongoing support.
            </Text>
            <Text type="secondary">
              <SafetyCertificateOutlined /> Crown Commercial Service supplier
              (G-Cloud 14) — authorised to deliver software and services to UK public sector organisations.
            </Text>
          </Space>
        </Paragraph>

        <Divider>Our Services</Divider>

        <Row gutter={[16, 16]}>
          {services.map((service, index) => (
            <Col xs={24} md={8} key={index}>
              <Card hoverable style={{ height: '100%' }}>
                <Space direction="vertical" size="middle">
                  {service.icon}
                  <Title level={5}>{service.title}</Title>
                  <Paragraph type="secondary">{service.description}</Paragraph>
                </Space>
              </Card>
            </Col>
          ))}
        </Row>

        <Divider>Flexible Engagement Models</Divider>

        <Row justify="center">
          <Col span={20}>
            <List
              grid={{ gutter: 16, column: 3 }}
              dataSource={[
                { title: 'Fixed Price', tag: 'Projects', description: 'Defined scope, clear deliverables' },
                { title: 'Time & Materials', tag: 'Flexible', description: 'Pay for what you use' },
                { title: 'Enhancement Hours', tag: 'Annual', description: 'Pre-purchased support hours' },
              ]}
              renderItem={(item) => (
                <List.Item>
                  <Card size="small" style={{ textAlign: 'center' }}>
                    <Tag color="blue">{item.tag}</Tag>
                    <Title level={5} style={{ marginTop: 8 }}>{item.title}</Title>
                    <Text type="secondary">{item.description}</Text>
                  </Card>
                </List.Item>
              )}
            />
          </Col>
        </Row>

        <Divider />

        <Row justify="center" style={{ marginBottom: 24 }}>
          <Space direction="vertical" align="center" size="middle">
            <GlobalOutlined style={{ fontSize: 32, color: '#4573D2' }} />
            <Title level={4}>Ready to get started?</Title>
            <Paragraph type="secondary" style={{ textAlign: 'center', maxWidth: 500 }}>
              Whether you need a quick integration, a custom Asana app, or
              strategic consultancy, BDQ can help.
            </Paragraph>
            <Button
              type="primary"
              size="large"
              icon={<RocketOutlined />}
              href="https://www.bdq.cloud/contact"
              target="_blank"
              rel="noopener noreferrer"
            >
              Contact BDQ
            </Button>
          </Space>
        </Row>
      </Col>
    </Row>
  );
};

export default GetHelp;
